/* Local dependencies */
import { Warehouse } from '../../types';
import {
  ListWarehousesActionTypes,
  ListWarehousesError,
  ListWarehousesInput,
  ListWarehousesRequest,
  ListWarehousesSuccess,
  ResetListWarehousesError,
  ResetListWarehousesState,
} from './types';

export function listWarehouses(input: ListWarehousesInput): ListWarehousesRequest {
  return {
    type: ListWarehousesActionTypes.LIST_WAREHOUSES,
    input,
  };
}

export function listWarehousesSuccess(total: number, warehouses: Warehouse[]): ListWarehousesSuccess {
  return {
    type: ListWarehousesActionTypes.LIST_WAREHOUSES_SUCCESS,
    warehouses,
    total,
  };
}

export function listWarehousesError(error: Error): ListWarehousesError {
  return {
    type: ListWarehousesActionTypes.LIST_WAREHOUSES_ERROR,
    error,
  };
}

export function resetListWarehousesError(): ResetListWarehousesError {
  return {
    type: ListWarehousesActionTypes.LIST_WAREHOUSES_RESET_ERROR,
  };
}

export function resetListWarehousesState(): ResetListWarehousesState {
  return {
    type: ListWarehousesActionTypes.LIST_WAREHOUSES_RESET_STATE,
  };
}
